import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { AlertCard } from './metric-card'

const BloqueAlertas = ({ data }) => (
    <Row className='g-2'>
        <Col xs={6}><AlertCard label='Sin movimiento > 30 días' value={data?.sinMovimiento30Dias} nota='Casos activos sin hito de gestión' /></Col>
        <Col xs={6}><AlertCard label='Sin movimiento > 60 días' value={data?.sinMovimiento60Dias} nota='Casos activos sin hito de gestión' /></Col>
        <Col xs={6}><AlertCard label='Honorarios pend. de autorizar' value={data?.honorariosPendientesAutorizacion} nota='Tarea 78 pendiente' /></Col>
        <Col xs={6}><AlertCard label='Rendiciones pend. de visar' value={data?.rendicionesPendientesVisar} nota='Tarea 72 pendiente' /></Col>
    </Row>
)
export default BloqueAlertas
